import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactTable from "react-table";
import 'react-table/react-table.css';




const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class ArticleCategoryList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            articleCategories: [],
            filter: {},
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        
    }
    

    async componentDidMount() {
        
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        
        try {
            const articleCategories = await this.getArticleCategories();
            this.setState({ articleCategories });
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ articleCategories: [] });        
    }


    
    async getArticleCategories() {
        
        
        return API.get("colin", "/articlecategories");
      
    }

    

    addRecord = async event => {
        let articleCategories = [...this.state.articleCategories];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        articleCategories.unshift({
            article_category_code:"",
            description: "",
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({articleCategories});
    }

    

    async saveRecord(record) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/articlecategories/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/articlecategories/${record["article_category_code"]}`, {
            body: record
        });
        
        

       
    }

    validateRecord(record) {

       
        if (record.article_category_code === "") {
            return [false,"Code cannot be blank. The record has not been saved"];
        }

        if (record.description === "") {
            return [false,"Description cannot be blank. The record has not been saved"];
        }
       
        return [true,];
    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data);


        } catch (e) {
            alert("Error saving");
        }
    }

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let articleCategories = [...this.state.articleCategories];
        
        if (cellInfo.column.id === "article_category_code" && !articleCategories[cellInfo.index].new_record)
        {
            alert("You cannot modify an existing article category code");
            return
        }
        articleCategories[cellInfo.index][cellInfo.column.id] = event.target.value;
        articleCategories[cellInfo.index].modified = true;
        this.setState({articleCategories});
    };
    handleNumberChange = (cellInfo, event) => {
        let articleCategories = [...this.state.articleCategories];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        articleCategories[cellInfo.index][cellInfo.column.id] = Number(val);
        articleCategories[cellInfo.index].modified = true;
        this.setState({articleCategories});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let articleCategories = [...this.state.articleCategories];
        articleCategories[cellInfo.index][cellInfo.column.id] = event.target.checked;
        articleCategories[cellInfo.index].modified = true;
        this.setState({articleCategories});
    };

    handleDateChange = (cellInfo, event) => {
        let articleCategories = [...this.state.articleCategories];
        articleCategories[cellInfo.index][cellInfo.column.id] = new Date(event);
        articleCategories[cellInfo.index].modified = true;
        this.setState({articleCategories});

    }

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false });
        let articleCategories = [...this.state.articleCategories];
        for (var i=0; i<articleCategories.length; i++){
            const validation = this.validateRecord(articleCategories[i]);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (articleCategories[i].hasOwnProperty("modified")) {
                    if (articleCategories[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (articleCategories[i].hasOwnProperty("new_record")) {
                                if (articleCategories[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(articleCategories[i]);
                            if (result.result) {
                                articleCategories[i].modified = false;
                                if (articleCategories[i].hasOwnProperty("new_record")) {
                                    if (articleCategories[i].new_record === true) {

                                  //      articleCategories[i].id = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    articleCategories[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        if (articleCategories[0].hasOwnProperty("sort_order")) {
            articleCategories.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        
        this.setState({articleCategories});

    }


    renderEditable = cellInfo => {
        const cellValue = this.state.articleCategories[cellInfo.index][cellInfo.column.id];


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }
        }
    }

    
    
    
    
      
    
    renderTable(data) {
        const columns = [

            {
                id: 'article_category_code',
                Header: 'Code',
                maxWidth: 150,
                accessor: 'article_category_code' ,
                Cell: this.renderEditable                
        },
        {
                id: 'description',
                Header: 'Description',
                maxWidth: 350,
                accessor: 'description' ,
                Cell: this.renderEditable                
        }
        
         
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={50}
                    sortable={false}
                />
            )
        }
    }

    
    renderComponent() {
        return (
            <div className="articleCategories">
                <Alert show={this.state.showAlert} variant="danger" dismissible >{this.state.errorMessage}</Alert>
                <Row >
                    <Col className="text-right" >                            
                            <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>
                            
                                
                                
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.articleCategories) : this.renderTable(this.state.articleCategories)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="CityscopeList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
